import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from './helpers'

export const GET_ACCOUNT_BALANCE = 'user/get account balance information'
export const getAccountBalance = fsa(GET_ACCOUNT_BALANCE)

export const GET_ACCOUNT_BALANCE_PENDING = 'user/get account balance information pending'
export const getAccountBalancePending = fsa(GET_ACCOUNT_BALANCE_PENDING)

export const GET_ACCOUNT_BALANCE_FAILURE = 'user/get account balance information failure'
export const getAccountBalanceFailure = fsaError(GET_ACCOUNT_BALANCE_FAILURE)

export const GET_ACCOUNT_BALANCE_SUCCESS = 'user/get account balance information success'
/**
 * @param {Object} payload Account balance information
 * @param {Number} payload.accountBalance Total account balance
 * @param {Object[]} payload.itemizedAccountBalances Sorted array of account balance transactions
 */
export const getAccountBalanceSuccess = fsaPayload(GET_ACCOUNT_BALANCE_SUCCESS)

// Expect LOGIN_VIA_LOGIN_FORM to carry a payload of: {context, email, password, nextRoute}.
export const LOGIN_VIA_LOGIN_FORM = 'login via the login form'
export const loginViaLoginForm = fsaPayload(LOGIN_VIA_LOGIN_FORM)

export const LOGOUT = 'logout'
export const logout = fsa(LOGOUT)

export const LOGOUT_TO_HOMEPAGE = 'logout to the homepage'
export const logoutToHomepage = fsa(LOGOUT_TO_HOMEPAGE)

// Expect REGISTER_VIA_REGISTRATION_FORM to carry a payload of: {context, email, password, nextRoute}
export const REGISTER_VIA_REGISTRATION_FORM = 'register via the registration form'
export const registerViaRegistrationForm = fsaPayload(REGISTER_VIA_REGISTRATION_FORM)

// Expect RESET_PASSWORD_REQUEST_VIA_PASSWORD_RESET_REQUEST_FORM to carry a payload of: {context, email}.
export const RESET_PASSWORD_REQUEST_VIA_PASSWORD_RESET_REQUEST_FORM =
  'reset password request via password reset form'
export const resetPasswordRequestViaPasswordResetRequestForm = fsaPayload(
  RESET_PASSWORD_REQUEST_VIA_PASSWORD_RESET_REQUEST_FORM,
)

// Expect RESET_USER_PASSWORD to carry a payload of: {password, passwordConfirmation, resetCode}
export const RESET_USER_PASSWORD = 'reset user password'
export const resetUserPassword = fsaPayload(RESET_USER_PASSWORD)

export const RESET_USER_PASSWORD_FAILURE = 'reset user password failure'
export const resetUserPasswordFailure = fsa(RESET_USER_PASSWORD_FAILURE)

export const RESET_USER_PASSWORD_SUCCESS = 'reset user password success'
export const resetUserPasswordSuccess = fsa(RESET_USER_PASSWORD_SUCCESS)

export const REGISTRATION_FINISHED = 'registration finished'
export const registrationFinished = fsa(REGISTRATION_FINISHED)

export const USER_AND_EVENT_PENDING = 'user and event pending'
export const userAndEventPending = fsa(USER_AND_EVENT_PENDING)

export const USER_AND_EVENT_RECEIVED = 'user and event received'
export const userAndEventReceived = fsa(USER_AND_EVENT_RECEIVED)

export const USER_AND_EVENT_NOT_RECEIVED = 'user and event not received'
export const userAndEventNotReceived = fsa(USER_AND_EVENT_NOT_RECEIVED)

export const UPDATE_NAME = 'update user first and last name'
export const updateName = fsaPayloadByKeys(UPDATE_NAME, ['firstName', 'lastName'])

export const UPDATE_USER_INFO = 'update user first and last name and email address'
export const updateUserInfo = fsaPayload(UPDATE_USER_INFO)

export const UPDATE_USER_INFO_SUCCESS = 'update user first and last name and email address success'
export const updateUserInfoSuccess = fsaPayload(UPDATE_USER_INFO_SUCCESS)

export const UPDATE_USER_INFO_FAILURE = 'update user first and last name and email address failure'
export const updateUserInfoFailure = fsa(UPDATE_USER_INFO_FAILURE)

export const UPDATE_USER_PASSWORD = 'update user password'
export const updateUserPassword = fsaPayload(UPDATE_USER_PASSWORD)

export const UPDATE_USER_PASSWORD_FAILURE = 'update user password failure'
export const updateUserPasswordFailure = fsa(UPDATE_USER_PASSWORD_FAILURE)

export const UPDATE_USER_PASSWORD_SUCCESS = 'update user password success'
export const updateUserPasswordSuccess = fsa(UPDATE_USER_PASSWORD_SUCCESS)
